import React from 'react'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  tabContent: {
    padding: theme.spacing(0, 0, 3, 0),
    background: theme.palette.primary.light,
    borderBottomRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderTopRightRadius: 8,
    boxShadow: `12px 8px 44px -12px rgba(127, 143, 164, 0.2)`,
  },
}))

export default function TabPanel({ children, openTab, tabValue }) {
  if (openTab === tabValue) {
    const classes = styles()
    return (
      <Grid
        container
        justify="flex-start"
        alignItems="flex-start"
        alignContent="flex-start"
        className={classes.tabContent}
      >
        {children}
      </Grid>
    )
  }
  return null
}
